import { normalizeRank } from './normalize';

export const resolveSubfamilyName = (recordId, recordMap, cache) => {
  if (!recordId) return null;
  if (cache.has(recordId)) return cache.get(recordId);
  const visited = [];
  const seen = new Set();
  let currentId = recordId;

  while (currentId) {
    if (cache.has(currentId)) {
      const cached = cache.get(currentId);
      visited.forEach((id) => cache.set(id, cached));
      return cached;
    }
    if (seen.has(currentId)) break;
    seen.add(currentId);
    visited.push(currentId);
    const current = recordMap.get(currentId);
    if (!current) break;
    const rank = normalizeRank(current.current_rank);
    if (rank === 'subfamily') {
      const name = current.name_spell_valid || current.name_spell_original || current.id;
      visited.forEach((id) => cache.set(id, name || null));
      return name || null;
    }
    currentId = current.current_parent;
  }

  visited.forEach((id) => cache.set(id, null));
  return null;
};

export const resolveFamilyName = (recordId, recordMap, cache) => {
  if (!recordId) return null;
  if (cache.has(recordId)) return cache.get(recordId);
  const visited = [];
  const seen = new Set();
  let currentId = recordId;

  while (currentId) {
    if (cache.has(currentId)) {
      const cached = cache.get(currentId);
      visited.forEach((id) => cache.set(id, cached));
      return cached;
    }
    if (seen.has(currentId)) break;
    seen.add(currentId);
    visited.push(currentId);
    const current = recordMap.get(currentId);
    if (!current) break;
    const rank = normalizeRank(current.current_rank);
    if (rank === 'family') {
      const name = current.name_spell_valid || current.name_spell_original || current.id;
      visited.forEach((id) => cache.set(id, name || null));
      return name || null;
    }
    currentId = current.current_parent;
  }

  visited.forEach((id) => cache.set(id, null));
  return null;
};
